export default __webpack_public_path__ + "static/media/inspector-text-layer.9f51efee.svg";